// extracted by mini-css-extract-plugin
export default {"title":"styles_title__ueqlP","logo_container":"styles_logo_container__YcEXf","logo":"styles_logo__K9THJ","hideOnPrint":"styles_hideOnPrint__kE8c3"};